(() => {
  function init(root) {
    if (!root || root.dataset.customerGalleryReady === 'true') return;
    root.dataset.customerGalleryReady = 'true';

    const rail = root.querySelector('[data-customer-rail]');
    const prev = root.querySelector('[data-customer-prev]');
    const next = root.querySelector('[data-customer-next]');
    const modal = root.querySelector('[data-customer-modal]');
    const content = modal?.querySelector('[data-customer-content]');
    let lastTrigger = null;

    const scrollAmount = () => Math.max(260, Math.round((rail?.clientWidth || 300) * .72));
    prev?.addEventListener('click', () => rail?.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
    next?.addEventListener('click', () => rail?.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));

    function closeModal() {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('loot-customer-modal-lock');
      content?.querySelectorAll('video').forEach((video) => {
        try { video.pause(); } catch (error) {}
      });
      if (content) content.innerHTML = '';
      lastTrigger?.focus();
    }

    root.querySelectorAll('[data-customer-open]').forEach((button) => {
      button.addEventListener('click', () => {
        const template = document.getElementById(button.dataset.templateId || '');
        if (!template || !modal || !content) return;
        lastTrigger = button;
        content.innerHTML = '';
        content.appendChild(template.content.cloneNode(true));
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('loot-customer-modal-lock');
        modal.querySelector('[data-customer-close]')?.focus();
      });
    });

    modal?.querySelectorAll('[data-customer-close]').forEach((button) => button.addEventListener('click', closeModal));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal?.classList.contains('is-open')) closeModal();
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-loot-customer-gallery]').forEach(init);
  });
})();
